<p-tieredMenu
  #menu
  popup="true"
  [model]="menuItems"
  appendTo="body"
  styleClass="bfx-blotter-settings-menu bfx-dashboard-menu"
></p-tieredMenu>
